import { useEffect, useState } from 'react';
import { getAllAgents } from '../../../../actions/agent';
import { Button, CircularProgress } from '@mui/material';
import TableHead from '@mui/material/TableHead';
import TableContainer from '@mui/material/TableContainer';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import Paper from '@mui/material/Paper';

import '../../AgentStyle.css';
import Box from '@mui/material/Box';
import jwt_decode from 'jwt-decode';
import { getToken } from '../../../../utils/token';

const AgentTableCell = ({ value, type = 'row' }) => (
  <TableCell
    sx={{
      whiteSpace: 'nowrap',
      fontSize: "14px",
      fontFamily: ['Montserrat'],
      fontWeight: type === 'header' ? '550' : '400'
    }}
  >
    {value}
  </TableCell>
);

export const AgentTable = ({ onEdit }) => {
  const [agents, setAgents] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const decodedToken = jwt_decode(getToken());
  const isReaderAccess = decodedToken.role === 'Читатель';

  useEffect(() => {
    setIsLoading(true);
    getAllAgents()
      .then((data) => setAgents(data))
      .catch((error) => console.error('Ошибка при загрузке агентов:', error))
      .finally(() => setIsLoading(false));
  }, []);

  if (isLoading)
    return <CircularProgress color="warning" />;

  return (
    <div>
      {!isReaderAccess && <Button className="addAgentButton" variant="contained" color="warning" onClick={() => onEdit(null)}>
        Добавить нового агента
      </Button>}

      <TableContainer component={Paper} style={{ marginTop: '20px' }}>
        <Table>
          <TableHead>
            <TableRow>
              <AgentTableCell value="Имя" type="header" />
              <AgentTableCell value="Компания" type="header" />
              <AgentTableCell value="Email" type="header" />
              <AgentTableCell value="Телефон" type="header" />
              {!isReaderAccess && <AgentTableCell value="" />}
            </TableRow>
          </TableHead>
          <TableBody>
            {agents && agents.length > 0
              ?
              agents.map((agent) => (
                <TableRow key={agent.id}>
                  <AgentTableCell value={agent.name} />
                  <AgentTableCell value={agent.company} />
                  <AgentTableCell value={agent.email} />
                  <AgentTableCell value={agent.phone_number} />
                  {!isReaderAccess && <TableCell>
                    <IconButton onClick={() => onEdit(agent)}>
                      <EditIcon />
                    </IconButton>
                  </TableCell>}
                </TableRow>
              ))
              :
              <TableRow>
                <TableCell colSpan={5} align="center">
                  <Box sx={{ display: 'flex', justifyContent: 'center', padding: '10px 20px' }}>
                    Нет данных
                  </Box>
                </TableCell>
              </TableRow>
            }
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
